<template>
    <div class="section mb-3">
      <h4 class="section-title">
        <font-awesome-icon :icon="['fas', 'tasks']" /> ¿Tarea aporta a un Cumplimiento?
      </h4>
  
      <!-- Checkbox para mostrar/ocultar el formulario -->
      <div class="form-check mb-3">
        <input
          type="checkbox"
          id="toggleCumplimiento"
          class="form-check-input"
          v-model="mostrarCumplimiento"
          @change="resetCumplimiento"
        />
        <label for="toggleCumplimiento" class="form-check-label">Agregar información de cumplimiento</label>
      </div>
  
      <!-- Formulario de selección, visible solo si el checkbox está marcado -->
      <transition name="fade">
        <div v-if="mostrarCumplimiento">
          <!-- Selección de grupo -->
          <div class="mb-2">
            <label for="grupoSelect" class="form-label">Seleccionar Grupo de Cumplimiento</label>
            <select
              id="grupoSelect"
              class="form-select form-select-sm"
              v-model="selectedGrupoId"
              @change="fetchEtiquetas"
            >
              <option value="" disabled selected>Seleccione un grupo</option>
              <option v-for="grupo in grupos" :key="grupo.id" :value="grupo.id">
                {{ grupo.nombre }}
              </option>
            </select>
          </div>
  
          <!-- Selección de etiqueta -->
          <div v-if="etiquetas.length" class="mb-2">
            <label for="etiquetaSelect" class="form-label">Seleccionar Etiqueta</label>
            <select
              id="etiquetaSelect"
              class="form-select form-select-sm"
              v-model="selectedEtiquetaId"
            >
              <option value="" disabled selected>Seleccione una etiqueta</option>
              <option v-for="etiqueta in etiquetas" :key="etiqueta.id" :value="etiqueta.id">
                {{ etiqueta.nombre }} ({{ etiqueta.descripcion }})
              </option>
            </select>
          </div>
  
          <!-- Detalles de la etiqueta seleccionada -->
          <div v-if="selectedEtiqueta" class="mt-3 p-2 bg-light rounded">
            <h5 class="mb-1 d-flex align-items-center">
              <span class="me-2" :style="{ backgroundColor: selectedGrupo.color || '#ccc', width: '20px', height: '20px', borderRadius: '50%' }"></span>
              {{ selectedEtiqueta.nombre }}
            </h5>
            <p class="mb-1"><strong>Descripción:</strong> {{ selectedEtiqueta.descripcion }}</p>
            <p class="mb-0">
              <strong>Obligatoria:</strong> 
              <span :class="{'text-success': selectedEtiqueta.es_obligatoria, 'text-danger': !selectedEtiqueta.es_obligatoria}">
                {{ selectedEtiqueta.es_obligatoria ? 'Sí' : 'No' }}
              </span>
            </p>
          </div>
  
          <!-- Mensaje si no hay etiquetas -->
          <p v-else-if="selectedGrupoId && !etiquetas.length" class="text-muted">
            Este grupo no tiene etiquetas disponibles.
          </p>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    data() {
      return {
        mostrarCumplimiento: false, // Controla si se muestra el formulario
        grupos: [],
        clubActual: null,
        etiquetas: [],
        selectedGrupoId: null,
        selectedEtiquetaId: null,
        selectedGrupo:{},
      };
    },
    computed: {
      selectedEtiqueta() {
        return this.etiquetas.find(etiqueta => etiqueta.id === this.selectedEtiquetaId);
      },
    },
    mounted() {
      this.clubActual = this.$store.getters.getClubActual;
      this.fetchGrupos();
    },
    watch: {
      selectedGrupoId(newGrupoId) {
        this.$emit('actualizar-cumplimiento', {
          grupoId: newGrupoId,
          etiquetaId: this.selectedEtiquetaId || null,
        });

        this.selectedGrupo = this.grupos.find(grupo => grupo.id === newGrupoId);
      },
      selectedEtiquetaId(newEtiquetaId) {
        this.$emit('actualizar-cumplimiento', {
          grupoId: this.selectedGrupoId,
          etiquetaId: newEtiquetaId,
        });
      },
    },
    methods: {
      async fetchGrupos() {
        try {
          const response = await axios.get('/api/cumplimiento/grupos',{params: {club_id: this.clubActual.id}});
          this.grupos = response.data;
        } catch (error) {
          console.error('Error al cargar grupos:', error);
        }
      },
      async fetchEtiquetas() {
        if (!this.selectedGrupoId) {
          this.etiquetas = [];
          return;
        }
  
        try {
          const response = await axios.get(
            `/api/cumplimiento/grupos/${this.selectedGrupoId}/etiquetas`,
            { params: { club_id: this.clubActual.id } }
          );
          this.etiquetas = response.data;
        } catch (error) {
          console.error('Error al cargar etiquetas:', error);
        }
      },
      resetCumplimiento() {
        if (!this.mostrarCumplimiento) {
          this.selectedGrupoId = null;
          this.selectedEtiquetaId = null;
          this.$emit('actualizar-cumplimiento', { grupoId: null, etiquetaId: null });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .section {
    border: 1px solid #e3e3e3;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }
  
  .section-title {
    margin-bottom: 10px;
    font-size: 1.1rem;
    color: var(--app-primary);
  }
  
  .form-label {
    margin-bottom: 0.2rem;
  }
  
  .form-select-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    transition: border-color 0.3s ease;
  }
  
  .form-select-sm:focus {
    border-color: var(--app-primary);
  }
  
  .bg-light {
    background-color: #f8f9fa !important;
  }
  
  .text-success {
    color: #28a745 !important;
  }
  
  .text-danger {
    color: #dc3545 !important;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  </style>
  